
export interface Rating {
  id?: number;
  comment: string;
  subject: string;
  rating: number;
  date?: string;
}

export interface RatingRequest {
  comment: string;
  subject: string;
  rating: number;
}

export interface AverageRatingResponse {
  providerId: number | string;
  averageRating: number;
  totalPeopleRating: number;
}
